import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.deleteDialogHeader',
    defaultMessage: 'Warning',
  },
  textContent: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.deleteDialogText',
    defaultMessage: 'Are you sure you wish to remove this flow response?',
  },
  cancel: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.deleteDialogCancel',
    defaultMessage: 'No, leave as is',
  },
  confirm: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.deleteDialogConfirm',
    defaultMessage: 'Yes, remove',
  },
  success: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.success',
    defaultMessage: 'Flow successfully deleted',
  },
  error: {
    id: 'components.CardLumaBotFlow.components.DeleteDialog.error',
    defaultMessage: 'Flow failed to be deleted',
  },
});
